import BaseComponent from './BaseComponent';
import cookieValue from './helper/cookieValue';

const isTruthyCookieValue = (value) => value === true || value === 'true' || value === 1 || value === '1';

class NewsOverview extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.useCookieFilter = el.dataset.useCookieFilter !== 'false';
        this.urlParams = new URLSearchParams(window.location.search);
        this.loadInitialNews();
    }

    loadInitialNews() {
        const listEl = this.el.querySelector('.js-news-overview-list');
        if (!listEl) {
            return;
        }

        const dioceseIds = this.resolveDioceseIdsForInitialLoad();
        this.urlParams.set('newsOverviewFragment', '1');
        this.urlParams.delete('dioceses[]');
        dioceseIds.forEach((id) => this.urlParams.append('dioceses[]', id));

        fetch(`?${this.urlParams}`)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject(response);
            })
            .then((html) => {
                listEl.innerHTML = html;
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    resolveDioceseIdsForInitialLoad() {
        if (!this.useCookieFilter) {
            return [];
        }
        const cookieSelection = this.cookieSelection();
        // If cookie exists, it is the source of truth even when all options are false.
        if (cookieSelection.hasCookie) {
            return cookieSelection.ids;
        }
        return this.requiredDioceseIds();
    }

    cookieSelection() {
        const cookie = cookieValue('newsCategories');
        if (!cookie || !cookie.categories || typeof cookie.categories !== 'object') {
            return {
                hasCookie: false,
                ids: []
            };
        }

        return {
            hasCookie: true,
            ids: Object.keys(cookie.categories).filter((id) => isTruthyCookieValue(cookie.categories[id]))
        };
    }

    requiredDioceseIds() {
        const requiredNodes = this.el.querySelectorAll('.js-news-overview-required-dioceses [data-required-diocese-id]');
        return Array.from(requiredNodes)
            .map((node) => node.dataset.requiredDioceseId)
            .filter((id) => id && id.length > 0);
    }
}

export default NewsOverview;
